import React from "react";
import QRCode from "qrcode";
import pdfMake from "pdfmake/build/pdfmake";
import {FormattedMessage} from 'react-intl';
import pdfFonts from "pdfmake/build/vfs_fonts";
import Config from '../../commons/config/Config.js'
import ConfigBusiness from "../../commons/config/ConfigBusiness.js";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default function QRGenerator() {
  const generatePDF = async () => {
    const token = ConfigBusiness.get('reportarIncidentes.tokenUrl');
    const url = `${window.location.origin}/reporte-formulario/${token}`;

    // 🔹 Tamaños más grandes
    const qrSize = 700;        // tamaño del QR en canvas
    const squareSize = 250;    // tamaño del cuadrado blanco detrás del logo
    const pdfImageWidth = 550; // tamaño del QR en el PDF

    // Generar QR en Base64
    const qrDataUrl = await QRCode.toDataURL(url, {
      errorCorrectionLevel: "H",
      margin: 1,
      width: qrSize,
    });

    // Función para cargar imagen y convertir a Base64
    const loadImageBase64 = async (url) => {
      const res = await fetch(url);
      const blob = await res.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    };

    const logoBase64 = await loadImageBase64(
      process.env.PUBLIC_URL + "/images/company/logo-login-app.png"
    );

    // Canvas temporal
    const canvas = document.createElement("canvas");
    canvas.width = qrSize;
    canvas.height = qrSize;
    const ctx = canvas.getContext("2d");

    // Dibujar QR
    const qrImg = new Image();
    qrImg.src = qrDataUrl;
    await new Promise((resolve) => (qrImg.onload = resolve));
    ctx.drawImage(qrImg, 0, 0, qrSize, qrSize);

    // Dibujar cuadrado blanco y logo proporcional
    const logoImg = new Image();
    logoImg.src = logoBase64;
    await new Promise((resolve) => (logoImg.onload = resolve));

    const x = (qrSize - squareSize) / 2;
    const y = (qrSize - squareSize) / 2;

    // Fondo blanco
    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(x, y, squareSize, squareSize);

    // Escalar logo proporcionalmente dentro del cuadrado
    const logoAspect = logoImg.width / logoImg.height;
    let logoWidth = squareSize;
    let logoHeight = squareSize;

    if (logoAspect > 1) {
      logoHeight = squareSize / logoAspect;
    } else {
      logoWidth = squareSize * logoAspect;
    }

    const logoX = x + (squareSize - logoWidth) / 2;
    const logoY = y + (squareSize - logoHeight) / 2;

    ctx.drawImage(logoImg, logoX, logoY, logoWidth, logoHeight);

    const finalImg = canvas.toDataURL("image/png");

    // Crear PDF centrado con QR más grande
    const docDefinition = {
      pageSize: "A4",
      pageMargins: [0, 0, 0, 0],
      content: [
        {
          image: finalImg,
          width: pdfImageWidth,
          alignment: "center",
          margin: [0, 120, 0, 0], // ajustar margen superior para centrar vertical
        },
      ],
    };

    pdfMake.createPdf(docDefinition).download("qr-vecfleet.pdf");
  };

  return (
    <div className="flex flex-col items-center">
      <button
        onClick={generatePDF}
        className="btn btn-primary"
      >
        <FormattedMessage id="Reportar_Incidente_Generar_QR" defaultMessage="Generar QR"/>
      </button>
    </div>
  );
}
